import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from '..';

export default function TwoColumnsFlexLayout({
  preset, flexLeft, flexRight, leftContent, rightContent, leftColumnStyle, rightColumnStyle, ...rest
}) {
  let fl = 1;
  let fr = 1;
  switch (preset) {
    case 'golden':
      fl = 1.61803;
      break;

    default:
      break;
  }
  if (flexLeft !== null) {
    fl = flexLeft;
  }
  if (flexRight !== null) {
    fr = flexRight;
  }
  return (
    <Flex {...rest}>
      <Box flex={fl} style={leftColumnStyle}>
        {leftContent}
      </Box>
      <Box flex={fr} style={rightColumnStyle}>
        {rightContent}
      </Box>
    </Flex>
  );
}

TwoColumnsFlexLayout.propTypes = {
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
  flexLeft: PropTypes.number,
  flexRight: PropTypes.number,
  preset: PropTypes.oneOf(['golden', null]),
};

TwoColumnsFlexLayout.defaultProps = {
  leftContent: null,
  rightContent: null,
  preset: null,
  flexLeft: null,
  flexRight: null,
};
